var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    viewBox: "0 0 939 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4342_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 939,
    height: 359
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M939 0.5H0V358.5H939V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4342_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.066 165.73H148.422V345.73H162.066V165.73Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6032 168.617L138.881 228.247L138.105 255.008V258.006L38.4922 199.82C38.4922 172.948 38.4922 196.489 38.4922 168.617H38.6032Z",
    fill: "#80A73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3802 173.395L138.771 233.024C138.771 233.024 138.771 232.691 138.105 258.009L137.772 255.899L38.4922 199.823C39.3802 174.838 38.4922 198.712 39.3802 173.395Z",
    fill: "url(#paint0_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.105 258.006L38.4922 200.819V196.488L138.327 253.12V257.895L138.105 258.006Z",
    fill: "#3B5020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.699 83.2249C189.571 103.657 183.692 125.643 165.056 138.413C162.727 139.968 160.287 141.411 156.959 143.41C160.287 124.311 157.402 106.988 149.97 90.3319H149.859L151.967 53.9099C151.967 53.9099 151.967 54.1319 152.3 54.2429C162.838 62.2379 173.709 70.7889 179.699 83.0029V83.2249Z",
    fill: "#E2BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.86 90.4429H149.971C148.64 107.655 146.2 124.977 144.758 142.855C137.88 139.857 132.888 135.304 128.34 130.196C111.701 111.652 112.921 86.2229 131.668 68.3459C136.993 63.2379 145.645 58.7959 151.635 54.3539C151.857 54.1319 151.968 54.0209 152.079 53.9099L149.971 90.3319L149.86 90.4429Z",
    fill: "#C59671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.547 161.068C138.547 161.068 131.226 159.624 117.915 154.516C107.82 150.741 97.2816 147.743 86.9656 144.633C80.9756 142.857 75.0966 141.08 69.1066 139.303C65.1126 138.193 58.0136 137.416 54.7966 134.862C65.1126 142.746 75.8726 150.075 87.5206 156.071C101.497 163.289 116.583 170.284 131.891 174.504C128.12 175.059 124.57 176.725 120.91 177.835C118.913 178.39 116.916 178.945 115.031 179.723H111.481C108.042 178.945 104.492 179.057 101.054 179.057C100.388 179.057 99.6116 179.057 98.9456 179.057C98.6126 178.723 98.0586 178.612 97.6146 178.501C89.6276 177.502 81.6406 175.947 73.8756 173.615C73.0996 173.393 72.4336 173.615 71.8796 174.06C69.3276 173.282 66.7766 172.394 64.2256 171.395C63.5596 171.061 64.2256 171.506 63.7816 172.061C55.6836 167.73 46.0336 162.511 38.6016 157.181V113.209C38.6016 113.209 60.3426 111.654 94.8416 123.424C129.34 135.195 138.658 161.068 138.658 161.068H138.547Z",
    fill: "url(#paint1_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.626 166.065L155.744 179.168L54.5781 135.195L159.515 166.065H159.626Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4922 117.426C38.4922 117.426 47.4772 117.315 48.1432 117.315C53.3562 117.315 58.5702 117.759 63.7842 118.425C82.7522 121.09 101.721 126.42 116.807 138.746C132.559 151.627 131.893 157.956 131.893 157.956L137.883 159.733C137.883 159.733 131.782 133.86 94.5112 121.978C57.2392 110.097 38.4922 113.095 38.4922 113.095V117.426Z",
    fill: "#80A73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4954 112.984C38.4954 112.984 40.9364 119.203 45.2624 125.31C49.5884 131.417 54.5804 135.193 54.5804 135.193L72.7724 147.63L85.6394 155.069C85.6394 155.069 78.7624 168.95 71.7734 171.059C64.7854 173.058 60.6814 170.837 60.6814 170.837L38.2734 157.29V113.095L38.4954 112.984Z",
    fill: "url(#paint2_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.602 165.286C90.2967 157.735 85.7487 155.07 85.7487 155.07C85.7487 155.07 77.8727 165.841 67.7787 169.062C64.1177 170.283 61.8997 170.838 60.6797 170.616C66.6697 173.503 88.1897 183.386 102.721 182.831C119.693 182.276 133.337 174.947 133.337 174.947C133.337 174.947 126.127 173.281 107.713 165.175L107.602 165.286Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4922 110.877V112.986C38.4922 112.986 52.6912 112.209 66.4462 114.874C80.2012 117.539 96.5072 122.536 96.5072 122.536C96.5072 122.536 85.5252 117.983 72.8802 114.763C59.3472 111.321 38.4922 110.766 38.4922 110.766V110.877Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.494 161.732C171.494 161.732 178.815 160.288 192.126 155.18C202.221 151.405 212.759 148.407 223.075 145.298C229.065 143.521 234.944 141.744 240.934 139.967C244.928 138.857 252.027 138.08 255.244 135.526C244.928 143.41 234.168 150.739 222.52 156.735C208.543 163.953 193.346 170.948 178.149 175.168C181.921 175.723 185.471 177.389 189.131 178.499C191.128 179.054 193.125 179.61 195.01 180.387H198.56C201.999 179.61 205.548 179.721 208.987 179.721C209.653 179.721 210.429 179.721 211.095 179.721C211.428 179.387 211.982 179.276 212.426 179.165C220.413 178.166 228.399 176.611 236.164 174.28C236.941 174.057 237.606 174.28 238.161 174.724C240.712 173.946 243.264 173.058 245.815 172.059C246.481 171.726 245.815 172.17 246.259 172.725C254.356 168.394 264.007 163.175 271.439 157.845V113.873C271.439 113.873 249.698 112.318 215.199 124.088C180.701 135.859 171.383 161.732 171.383 161.732H171.494Z",
    fill: "url(#paint3_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.414 166.729L154.297 179.832L255.351 135.859L150.414 166.729Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.547 117.984C271.547 117.984 262.562 117.873 261.896 117.873C256.683 117.873 251.469 118.317 246.256 118.984C227.287 121.649 208.319 126.979 193.232 139.304C177.481 152.185 178.146 158.515 178.146 158.515L172.156 160.291C172.156 160.291 178.257 134.419 215.529 122.537C252.8 110.656 271.547 113.654 271.547 113.654V117.984Z",
    fill: "#80A73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.55 113.652C271.55 113.652 269.11 119.871 264.784 125.978C260.458 132.085 255.466 135.861 255.466 135.861L237.274 148.298L224.406 155.737C224.406 155.737 231.284 169.618 238.272 171.727C245.261 173.726 249.365 171.505 249.365 171.505L271.772 157.958V113.763L271.55 113.652Z",
    fill: "url(#paint4_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.446 165.841C219.751 158.29 224.299 155.625 224.299 155.625C224.299 155.625 232.175 166.396 242.269 169.616C245.93 170.838 248.148 171.393 249.368 171.171C243.378 174.058 221.858 183.941 207.327 183.386C190.355 182.83 176.711 175.502 176.711 175.502C176.711 175.502 183.921 173.836 202.335 165.73L202.446 165.841Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.546 111.541V113.651C271.546 113.651 257.348 112.873 243.593 115.538C229.838 118.203 213.531 123.2 213.531 123.2C213.531 123.2 224.513 118.647 237.159 115.427C250.692 111.985 271.546 111.43 271.546 111.43V111.541Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6016 209.703L138.88 269.333L138.103 296.094V299.092L38.6016 240.906C38.6016 214.034 38.6016 237.575 38.6016 209.703Z",
    fill: "#E2BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4886 214.477L138.88 274.106C138.88 274.106 138.88 273.773 138.214 299.091L137.882 296.981L38.6016 240.905C39.4886 215.92 38.6016 239.794 39.4886 214.477Z",
    fill: "url(#paint5_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.105 299.092L38.4922 241.905V237.574L138.327 294.206L138.105 298.981V299.092Z",
    fill: "#B5825B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88 210.926L172.156 270.555L172.933 297.317V300.315L271.88 242.129C271.88 215.256 271.88 238.797 271.88 210.926Z",
    fill: "#E2BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.108 215.699L172.383 275.329C172.383 275.329 172.383 274.996 173.048 300.313L173.381 298.204L272.107 242.238C271.219 217.254 272.107 241.128 271.219 215.81L271.108 215.699Z",
    fill: "url(#paint6_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.939 300.314L271.997 243.128V238.797L172.828 295.428L173.05 300.203L172.939 300.314Z",
    fill: "#B5825B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.216 167.395L171.938 227.024L172.714 253.785V256.783L272.327 198.597C272.327 171.725 272.327 195.266 272.327 167.395H272.216Z",
    fill: "#80A73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.438 172.059L172.047 231.688C172.047 231.688 172.047 231.355 172.712 256.673L173.045 254.563L272.325 198.598C271.438 173.613 272.325 197.487 271.438 172.17V172.059Z",
    fill: "url(#paint7_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.714 256.674L272.327 199.487V195.156L172.492 251.788L172.714 256.563V256.674Z",
    fill: "#3B5020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.926 210.149C183.141 210.149 186.469 206.706 186.469 202.598C186.469 198.489 183.03 195.047 178.926 195.047C174.822 195.047 171.383 198.489 171.383 202.598C171.383 206.706 174.822 210.149 178.926 210.149Z",
    fill: "url(#paint8_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.926 205.151C180.368 205.151 181.478 204.04 181.478 202.597C181.478 201.153 180.368 200.043 178.926 200.043C177.484 200.043 176.375 201.153 176.375 202.597C176.375 204.04 177.484 205.151 178.926 205.151Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4024 104.656C95.6184 104.656 98.9454 101.214 98.9454 97.106C98.9454 92.997 95.5074 89.5549 91.4024 89.5549C87.2984 89.5549 83.8594 92.997 83.8594 97.106C83.8594 101.214 87.2984 104.656 91.4024 104.656Z",
    fill: "url(#paint9_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4026 99.659C92.8446 99.659 93.9536 98.548 93.9536 97.105C93.9536 95.661 92.8446 94.551 91.4026 94.551C89.9606 94.551 88.8516 95.661 88.8516 97.105C88.8516 98.548 89.9606 99.659 91.4026 99.659Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.678 212.59C129.785 212.59 131.449 210.924 131.449 208.814C131.449 206.705 129.785 205.039 127.678 205.039C125.57 205.039 123.906 206.705 123.906 208.814C123.906 210.924 125.57 212.59 127.678 212.59Z",
    fill: "url(#paint10_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.567 193.604C196.009 193.604 197.118 192.494 197.118 191.05C197.118 189.607 196.009 188.496 194.567 188.496C193.125 188.496 192.016 189.607 192.016 191.05C192.016 192.494 193.125 193.604 194.567 193.604Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.636 104.658C225.625 104.658 231.171 98.995 231.171 92.11C231.171 85.226 225.514 79.562 218.636 79.562C211.759 79.562 206.102 85.226 206.102 92.11C206.102 98.995 211.759 104.658 218.636 104.658Z",
    fill: "url(#paint11_linear_4342_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.637 96.2169C220.967 96.2169 222.852 94.3289 222.852 91.9969C222.852 89.6649 220.967 87.7769 218.637 87.7769C216.308 87.7769 214.422 89.6649 214.422 91.9969C214.422 94.3289 216.308 96.2169 218.637 96.2169Z",
    fill: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.744 358.5L0 269V90L154.744 0.5L309.487 90V269L154.744 358.5ZM17.859 258.673L154.855 337.846L291.85 258.673V100.327L154.744 21.154L17.859 100.327V258.673Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.312 93.7769H380.813L484.974 214.924H485.639V93.7769H520.693V260.452H487.193L383.031 139.527H382.367V260.452H347.312V93.7769Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.966 93.7769H660.69L740.55 260.452H703.28L684.31 220.921H602.006L583.037 260.452H545.766L625.966 93.7769ZM675.77 197.824L643.27 127.312H642.61L610.769 197.824H675.77Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.73 93.7769H799.23L903.401 214.924H904.061V93.7769H939.11V260.452H905.61L801.45 139.527H800.791V260.452H765.73V93.7769Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.836 287.102H369.496V315.084H365.281L351.082 292.543V315.084H347.422V287.102H351.859L365.836 309.643V287.102Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.587 306.867L379.703 315.084H375.82L386.358 287.102H390.574L400.668 315.084H396.564L393.791 306.867H382.587ZM392.348 303.536L388.244 291.21L383.807 303.536H392.459H392.348Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.528 315.084H411.757V290.433H402.328V287.102H425.068V290.433H415.639V315.084H415.528Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.053 315.084H431.281V287.102H435.053V315.084Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.018 315.861C445.59 315.861 442.484 307.2 442.484 301.093C442.484 294.986 445.59 286.324 456.018 286.324C466.445 286.324 469.551 294.986 469.551 301.093C469.551 307.2 466.445 315.861 456.018 315.861ZM456.018 289.767C449.917 289.767 446.367 294.43 446.367 301.093C446.367 307.755 450.027 312.53 456.018 312.53C462.008 312.53 465.668 307.755 465.668 301.204C465.668 294.652 462.008 289.878 456.018 289.878V289.767Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.617 287.102H499.278V315.084H495.062L480.864 292.543V315.084H477.203V287.102H481.64L495.617 309.643V287.102Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.368 306.867L509.484 315.084H505.602L516.14 287.102H520.355L530.449 315.084H526.345L523.572 306.867H512.368ZM522.13 303.536L518.025 291.21L513.588 303.536H522.241H522.13Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.436 311.753H554.523V315.084H536.664V287.102H540.436V311.753Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.149 306.867L576.265 315.084H572.383L582.921 287.102H587.136L597.231 315.084H593.126L590.353 306.867H579.149ZM588.911 303.536L584.807 291.21L580.37 303.536H589.022H588.911Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.743 295.539C620.745 290.653 616.641 289.765 613.978 289.765C608.987 289.765 604.882 293.54 604.882 300.869C604.882 307.421 607.212 312.529 614.089 312.529C616.53 312.529 620.745 311.418 622.076 304.867H625.737C624.184 315.416 615.642 315.86 613.535 315.86C607.212 315.86 601 311.751 601 300.98C601 292.43 605.881 286.434 613.978 286.434C621.189 286.434 624.849 290.875 625.404 295.65H621.743V295.539Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.72 306.867L633.836 315.084H629.953L640.49 287.102H644.71L654.8 315.084H650.7L647.92 306.867H636.72ZM646.48 303.536L642.38 291.21L637.94 303.536H646.59H646.48Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.02 287.103H672.329C679.649 287.103 684.089 292.655 684.089 300.65C684.089 306.98 681.319 314.975 672.219 314.975H661.02V286.992V287.103ZM664.79 311.866H672.109C676.989 311.866 680.209 307.979 680.209 300.984C680.209 293.988 676.99 290.435 671.89 290.435H664.79V311.977V311.866Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.15 315.084H691.52V287.102H711.93V290.433H695.29V298.65H710.599V301.981H695.29V311.642H712.15V314.973V315.084Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.24 287.102L733.23 310.754L741.21 287.102H746.54V315.084H742.88V298.539C742.88 297.762 742.99 294.097 742.99 291.543L735.11 315.084H731.34L723.47 291.543H723.35C723.35 294.097 723.47 297.762 723.47 298.539V315.084H719.8V287.102H725.13H725.24Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.3 287.102L765.28 300.538L773.27 287.102H777.71L767.17 303.869V315.084H763.4V303.869L752.86 287.102H757.3Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.1 315.861C799.68 315.861 796.57 307.2 796.57 301.093C796.57 294.986 799.68 286.324 810.1 286.324C820.53 286.324 823.64 294.986 823.64 301.093C823.64 307.2 820.53 315.861 810.1 315.861ZM810.1 289.767C804 289.767 800.45 294.43 800.45 301.093C800.45 307.755 804.11 312.53 810.1 312.53C816.09 312.53 819.75 307.755 819.75 301.204C819.75 294.652 816.09 289.878 810.1 289.878V289.767Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.36 287.102V290.433H834.83V298.65H848.48V301.981H834.83V315.084H831.061V287.102H850.36Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.836 324.746H369.496V352.73H365.281L351.082 330.187V352.73H347.422V324.746H351.859L365.836 347.29V324.746Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.003 324.746V342.846C400.003 348.51 396.453 353.39 388.799 353.39C381.145 353.39 378.039 348.62 378.039 343.401V324.746H381.811V342.402C381.811 348.4 385.582 350.17 388.91 350.17C392.238 350.17 396.231 348.51 396.231 342.513V324.746H400.003Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.528 352.73H415.757V328.077H406.328V324.746H429.068V328.077H419.639V352.73H419.528Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.045 352.73H435.273V324.746H448.141C452.689 324.746 457.348 326.412 457.348 332.297C457.348 336.406 455.24 337.96 453.466 338.959C454.686 339.848 456.904 340.292 456.904 344.18V349.29C456.904 350.84 457.237 351.4 458.457 352.06V352.73H453.798C453.244 350.95 453.133 346.73 453.133 345.73C453.133 343.401 452.689 340.736 448.141 340.736H439.045V352.73ZM439.045 337.516H447.808C450.581 337.516 453.466 336.739 453.466 332.63C453.466 328.522 450.36 327.966 448.474 327.966H439.045V337.516Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 352.73H465.672V324.746H469.443V352.73Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.966 352.73H485.194V328.077H475.766V324.746H498.506V328.077H489.077V352.73H488.966Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.381 352.73H504.609V324.746H508.381V352.73Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.455 353.39C519.028 353.39 515.922 344.73 515.922 338.624C515.922 332.517 519.028 323.855 529.455 323.855C539.882 323.855 542.988 332.517 542.988 338.624C542.988 344.73 539.882 353.39 529.455 353.39ZM529.455 327.298C523.354 327.298 519.804 331.962 519.804 338.624C519.804 345.29 523.465 350.06 529.455 350.06C535.445 350.06 539.106 345.29 539.106 338.735C539.106 332.184 535.445 327.409 529.455 327.409V327.298Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.945 324.746H572.606V352.73H568.391L554.192 330.187V352.73H550.531V324.746H554.968L568.945 347.29V324.746Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.682 353.39C583.254 353.39 580.148 344.73 580.148 338.624C580.148 332.517 583.254 323.855 593.682 323.855C604.109 323.855 607.215 332.517 607.215 338.624C607.215 344.73 604.109 353.39 593.682 353.39ZM593.682 327.298C587.581 327.298 584.031 331.962 584.031 338.624C584.031 345.29 587.692 350.06 593.682 350.06C599.672 350.06 603.332 345.29 603.332 338.735C603.332 332.184 599.672 327.409 593.682 327.409V327.298Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.529 349.28H632.617V352.62H614.758V324.633H618.529V349.28Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.59 353.39C641.16 353.39 638.05 344.73 638.05 338.624C638.05 332.517 641.16 323.855 651.59 323.855C662.02 323.855 665.12 332.517 665.12 338.624C665.12 344.73 662.02 353.39 651.59 353.39ZM651.59 327.298C645.49 327.298 641.94 331.962 641.94 338.624C641.94 345.29 645.6 350.06 651.59 350.06C657.58 350.06 661.24 345.29 661.24 338.735C661.24 332.184 657.58 327.409 651.59 327.409V327.298Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75 337.738H696.949V352.73H694.51L693.62 349.06C691.74 351.73 688.19 353.39 684.42 353.39C674.65 353.39 671.439 345.18 671.439 338.404C671.439 331.631 675.54 323.969 684.64 323.969C689.85 323.969 695.62 326.967 696.4 333.185H692.74C691.52 328.299 687.41 327.3 684.42 327.3C679.42 327.3 675.319 331.298 675.319 338.626C675.319 344.29 677.21 350.17 684.64 350.17C685.97 350.17 688.3 350.06 690.41 348.4C692.85 346.51 693.4 343.956 693.4 340.958H684.75V337.738Z",
    fill: "#314419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.6 324.746L715.59 338.182L723.57 324.746H728.01L717.47 341.513V352.73H713.7V341.513L703.16 324.746H707.6Z",
    fill: "#314419"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4342_106",
    x1: 46.1462,
    y1: 195.936,
    x2: 140.247,
    y2: 239.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#80A73E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4342_106",
    x1: 38.4906,
    y1: 146.521,
    x2: 138.547,
    y2: 146.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4342_106",
    x1: 50.8084,
    y1: 142.3,
    x2: 87.7504,
    y2: 149.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4C6D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4342_106",
    x1: 271.55,
    y1: 147.074,
    x2: 171.494,
    y2: 147.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4342_106",
    x1: 259.237,
    y1: 142.856,
    x2: 222.296,
    y2: 150.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4C6D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4342_106",
    x1: 46.1446,
    y1: 237.018,
    x2: 140.245,
    y2: 280.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E2BD9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4342_106",
    x1: 264.453,
    y1: 238.463,
    x2: 170.796,
    y2: 281.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E2BD9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4342_106",
    x1: 264.671,
    y1: 194.6,
    x2: 170.571,
    y2: 238.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#80A73E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4342_106",
    x1: 171.383,
    y1: 202.598,
    x2: 186.469,
    y2: 202.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4342_106",
    x1: 83.8594,
    y1: 97.1059,
    x2: 98.9454,
    y2: 97.1059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4342_106",
    x1: 123.906,
    y1: 208.814,
    x2: 131.449,
    y2: 208.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4342_106",
    x1: 205.991,
    y1: 91.999,
    x2: 231.171,
    y2: 91.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283816"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNan);
export default __webpack_public_path__ + "static/media/nan.960571132925d49683b79f75918d56f9.svg";
export { ForwardRef as ReactComponent };